import { Platform } from "@angular/cdk/platform";
import { Component, ElementRef, Host, HostListener, Input, OnChanges, OnDestroy, OnInit, Optional, Renderer2, SimpleChanges } from "@angular/core";
import { NgControl } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: ".custom-range[type=range]",
  template: "",
  styleUrls: ["./edp-range.component.scss"],

})
export class EdpRangeComponent implements OnInit, OnDestroy, OnChanges {
  private unsubscribe$: Subject<void> = new Subject();
  private _isCorrectBrowser: boolean = !this._platform.FIREFOX || !this._platform.EDGE;
  @Input() min =  0;
  @Input() max =  100;

  @HostListener("change") private _onChange(): void {
    const range: HTMLInputElement = this._el.nativeElement;
    const val = (Number(range.value) - this.min) / (this.max - this.min);
    this._render.setStyle(range, "background-image",
      "-webkit-gradient(linear, left top, right top, "
      + "color-stop(" + val + ", #f6334f), "
      + "color-stop(" + val + ", #f4f4f4)"
      + ")");
  }

  constructor(
    private readonly _el: ElementRef<HTMLInputElement>,
    private readonly _render: Renderer2,
    @Host() @Optional() private readonly ngControl: NgControl,
    private readonly _platform: Platform
    ) { }


  private usingNgControl(): void {
    if (this.ngControl) {
      this.ngControl.valueChanges.pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe((value) => {
        this._onChange();
      });
    }
  }

  public ngOnInit(): void {
    if (this._isCorrectBrowser) {
      this.usingNgControl();
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this._isCorrectBrowser) {
      this._onChange();
    }
  }


  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


}
